var _rect, _path, _rect2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect3, _path0, _rect4, _path1, _path10, _path11, _path12, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 46.7773,
    y: 13.1582,
    width: 209.221,
    height: 242.846,
    fill: "url(#pattern0_2319_47611)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M235.146 14.0928H66.7109C60.9076 14.0928 56.2031 18.7973 56.2031 24.6005V228.14C56.2031 233.943 60.9076 238.647 66.7109 238.647H235.146C240.95 238.647 245.654 233.943 245.654 228.14V24.6005C245.654 18.7973 240.95 14.0928 235.146 14.0928Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.12
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 51.6875,
    y: 10.5889,
    width: 199.881,
    height: 233.506,
    fill: "url(#pattern1_2319_47611)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M235.146 14.0928H66.7109C60.9076 14.0928 56.2031 18.7973 56.2031 24.6005V228.14C56.2031 233.943 60.9076 238.647 66.7109 238.647H235.146C240.95 238.647 245.654 233.943 245.654 228.14V24.6005C245.654 18.7973 240.95 14.0928 235.146 14.0928Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M154.43 14.085H66.7095C65.3333 14.0849 63.9706 14.3573 62.7001 14.8863C61.4296 15.4153 60.2763 16.1905 59.3068 17.1673C58.3373 18.144 57.5706 19.303 57.0511 20.5775C56.5315 21.8519 56.2693 23.2165 56.2796 24.5927V70.2042H154.43V14.085Z",
    fill: "#21A366"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M235.295 14.085H154.424V70.2042H245.569V24.5927C245.59 21.8398 244.521 19.1904 242.597 17.222C240.672 15.2536 238.047 14.126 235.295 14.085Z",
    fill: "#33C481"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M245.647 126.33H154.424V182.449H245.647V126.33Z",
    fill: "#107C41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M154.43 182.449V126.33H56.2796V228.061C56.2692 229.443 56.5339 230.815 57.0583 232.094C57.5827 233.374 58.3563 234.536 59.3341 235.514C60.312 236.492 61.4744 237.265 62.754 237.79C64.0335 238.314 65.4046 238.579 66.7873 238.568H235.301C236.683 238.579 238.054 238.314 239.334 237.79C240.613 237.265 241.776 236.492 242.754 235.514C243.732 234.536 244.505 233.374 245.03 232.094C245.554 230.815 245.819 229.443 245.808 228.061V182.449H154.43Z",
    fill: "#185C37"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M154.431 70.2041H56.2031V126.323H154.431V70.2041Z",
    fill: "#107C41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M245.647 70.2041H154.424V126.323H245.647V70.2041Z",
    fill: "#21A366"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2319_47611",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 56,
    y: 14,
    width: 190,
    height: 225
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M235.144 14.085H66.7089C60.9057 14.085 56.2012 18.7894 56.2012 24.5927V228.132C56.2012 233.935 60.9057 238.64 66.7089 238.64H235.144C240.948 238.64 245.652 233.935 245.652 228.132V24.5927C245.652 18.7894 240.948 14.085 235.144 14.085Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2319_47611)"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.48
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -24.9805,
    y: 49.7334,
    width: 177.464,
    height: 175.596,
    fill: "url(#pattern2_2319_47611)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M115.83 63.2021H10.5195C4.7162 63.2021 0.0117188 67.9066 0.0117188 73.7099V179.021C0.0117188 184.824 4.7162 189.529 10.5195 189.529H115.83C121.634 189.529 126.338 184.824 126.338 179.021V73.7099C126.338 67.9066 121.634 63.2021 115.83 63.2021Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.24
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -4.27539,
    y: 61.0977,
    width: 136.367,
    height: 134.499,
    fill: "url(#pattern3_2319_47611)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M115.83 63.1953H10.5195C4.7162 63.1953 0.0117188 67.8998 0.0117188 73.7031V179.014C0.0117188 184.817 4.7162 189.522 10.5195 189.522H115.83C121.634 189.522 126.338 184.817 126.338 179.014V73.7031C126.338 67.8998 121.634 63.1953 115.83 63.1953Z",
    fill: "white"
  })))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M115.819 63.2031H10.5078C4.70448 63.2031 0 67.9076 0 73.7109V179.022C0 184.825 4.70448 189.53 10.5078 189.53H115.819C121.622 189.53 126.327 184.825 126.327 179.022V73.7109C126.327 67.9076 121.622 63.2031 115.819 63.2031Z",
    fill: "#107C41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9277 160.495L54.7994 126.325L34.4844 92.1553H50.8298L61.8824 113.949C62.8943 115.973 63.5948 117.53 63.984 118.541C64.6845 116.907 65.4629 115.272 66.2412 113.716L78.0722 92.1553H93.0943L72.3902 126.325L93.717 160.806H78.15L65.3072 136.911C64.7236 135.891 64.2288 134.823 63.8283 133.719C63.4564 134.81 62.9602 135.855 62.3494 136.833L48.4948 160.495H32.9277Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M115.819 63.2031H10.5078C4.70448 63.2031 0 67.9076 0 73.7109V179.022C0 184.825 4.70448 189.53 10.5078 189.53H115.819C121.622 189.53 126.327 184.825 126.327 179.022V73.7109C126.327 67.9076 121.622 63.2031 115.819 63.2031Z",
    fill: "url(#paint0_linear_2319_47611)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_2319_47611",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2319_47611",
    transform: "scale(0.00884956 0.00763359)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1_2319_47611",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image1_2319_47611",
    transform: "scale(0.00925926 0.00793651)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern2_2319_47611",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image2_2319_47611",
    transform: "scale(0.0104167 0.0105263)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern3_2319_47611",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image3_2319_47611",
    transform: "scale(0.0135135 0.0136986)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2319_47611",
    x1: 21.9495,
    y1: 54.9526,
    x2: 104.377,
    y2: 197.702,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.7
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2319_47611",
    width: 113,
    height: 131,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHEAAACDCAYAAAC6JPTCAAAACXBIWXMAAC4jAAAuIwF4pT92AAAD0ElEQVR4Xu3YTU8TURiG4fsUbIsf+BWJGnXBwhh3/v8fYmKMGGPUGEXkS6jOHBfvOe1UxrKxRZ48d3JS6ExZcPGemSHlnHGXu/XzTgBIKaX65cIT3b8uA+RzJi0tOl7wBmWtlVdDrqYMtEBTXtu/YfYiFrxETOoQGJc1IjANudwygXcKnJQ1AX4RgzmHdgaxM31D4BpwE7gL3AGul/c9kcurTuAEOAR2ga/AHnBc3p+byrlrYgdwTODdBx4DT4AHwO1ybA23zBpi+r4BH4B3ZX0E9okJ7UckpmsIbBJ4z8raJkA3iS11gFtmLQG1T8C9JnZFiC21SSn9rNM4RSxTuAZsAFvAU+AF8Bx4xGwK1/FWuuwygXVCXMqul/ePgAMCuCnrzCQOmCFuE5Db5QdtMLtDdcuvJX7nw/L9AfCprO/AaUqpzTnnLmKdxBGxbW6VdQu4ClzBE7jK6qPdNWKIHpZ1h7hOHhLTemaq6mPFiICrfwl+rLiY6vP5mBis28ANZvclqZ70Z3Ui/YD/fzRgNlhjeoZq0fXNcP9P3f+cnRkq36RcrnoHy4gCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGVEgIwpkRIGMKJARBTKiQEYUyIgCGfFylfveXITY+wF3IWWg7aw5mz7EDDTl5Ppq0Iup4v0CToGT8trQMVnv+VD9wDHwA5gAo3I84VZZS/z+j4A9YBc4JHymw9VFrBN4CuwDn8u6WY4P8TV0ldWBOgI+Au+A98BXYriaeuKfk9iWEz4Db5gBbgEbwBpuVbXEQO0RgC+BHeALsa22Oef5Scw555RSwwzxVTn0nUC8ihFXWUNg7RITuAO8JVAnBDIAqWDGNyklYsscA5sE3j1iIkflmK+Ly6/e0EyAAwLyCwF4DPzMOfcjwhzkkNhCNwjAdQy4yuo1cULsjifl66YLCD2IMIVMxPY5KK8GXH11Iuuj3vQ62K0XcXowMMGAF1mGuGf52wkLEd3l6DfHVuwii6DFdAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image1_2319_47611",
    width: 108,
    height: 126,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGwAAAB+CAYAAADBePRdAAAACXBIWXMAAC4jAAAuIwF4pT92AAACb0lEQVR4Xu3XzXHaUBhG4XMJSxtKIAWkhbiANOAC0lN6SAMU4GxcAAVACYC38ZeFJFvDzzKId+acjcTVZfXMJy6tqjittTY7W7SbVVXv1561MVhrrQELYAU8AO3K9+z/VMAbsAOOl+A+wHqsJfAdeKZDE+y2FR3WGtgA26o6jDe0qhpjPQE/++sCm6IjsAVegV/AZjxp8/66oJusAWuJ0zVVS+Bbf/9CN3H74eGsP2Cs6F6DYt1HX4CvwA9gNT4EDjePdGgLxLqXBpPH8eL4+C7U/XVm4v+tsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLS7CwBAtLsLAEC0uwsAQLawxWV3fZVJ2ZDGBHYAccLm2ySRpMjuPFWVW99w9+Ay/AHtGm7i+wBdbArjcCYN5fD8AfoPWfn4AFNkVHOqxXYMPJhM0Bqqpaa3u6Cat+04pPQLtNRfe2W9NhbcfTBdCqPt9+rbVGN1kr4AHBbl0Bb/S/XadYcAL2sdiax/0JuwQ1dBHM7rd/jp90H8g9bqAAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image2_2319_47611",
    width: 96,
    height: 95,
    xlinkHref: "data:image/png;base64,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"
  }), /*#__PURE__*/React.createElement("image", {
    id: "image3_2319_47611",
    width: 74,
    height: 73,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEoAAABJCAYAAACaRLDfAAAACXBIWXMAAC4jAAAuIwF4pT92AAABy0lEQVR4Xu3cMVLCUBSF4f8ylKI7EHvXoDuwdwOuTXtXIKyB3rgDwZpncfMMJOCcmnf+hglkmMk3ScoTpRRqERHAAlgCV0DQRgX4ATpgVw5R+qJ+1yNdA4/AM4nVElQHvAErYDvGmsME6QV46I9b6p58mgBWEXGENe8/FwxIjyRSK3dT7Ya89toHsK0H84iYkY/ZM8Od1BoS5DVfkwY74DMiNqWUPcCsP6m+wFtFqlWsJcNjCAxQ9SSXTSwOodw/GUrMUGKGEjOUmKHEDCVmKDFDiRlKzFBihhIzlJihxAwlZigxQ4kZSsxQYoYSM5SYocQMJWYoMUOJGUrMUGKGEjOUmKHEDCVmKDFDiRlKzFBihhIzlJihxAwlZigxQ4kZSsxQYoYSM5SYocQMJWYoMUOJGUrMUGKGEjOUmKHEDCVmKDFDiRlK7BBqMi7VcBOLCrUjh6a2p05qqEIadKTJX7N+9qeuca2Bb2A//ocG2pPXviYtujqJBMPQ1o6cLIPcervnxDTQBVefqA3wSloc3VHjjbsFcEdCPQG3XP5cUgG+gHcS6pMTg4AxOqZfKFuQSC0sJ9bFxC8S6ORrZwL190OCNdM5oNpZKHfcL4k/bZY4tSNlAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/Excel.09456e0a3eff108561c93ff1013022a5.svg";
export { ForwardRef as ReactComponent };